import { Pipe, PipeTransform } from '@angular/core';
import { GetBlogDataQuery } from '@ng-chronicles/shared/data-access';

// Local type matching the transformed blog item where tags are strings
type BlogListItem = GetBlogDataQuery['blogPosts'][number] & { tags?: (string | null)[] };

@Pipe({
  name: 'blogPostView'
})
export class BlogPostViewPipe implements PipeTransform {
  transform(
    value: BlogListItem[] | undefined,
    slug: string
  ): BlogListItem | undefined {
    if (!value || !slug) return undefined;

    return value.find((item) => item?.slug === slug);
  }
}
